import { AxiosError } from 'axios';
import { getApiValidationIssues } from './errors';

const COMMUNITY_IMPORT_ALREADY_IN_PROGRESS_MESSAGE = 'a community import is already in progress for this list';

type ApiErrorResponse = {
  message?: unknown;
};

const getCommunityImportErrorMessages = ({ error }: { error: AxiosError<ApiErrorResponse> }): string[] => {
  const validationMessages = getApiValidationIssues(error).flatMap((issue) => issue.messages);
  const apiMessage = error.response?.data?.message;

  if (typeof apiMessage !== 'string') {
    return validationMessages;
  }

  return [...validationMessages, apiMessage];
};

export const isCommunityImportAlreadyInProgressError = ({ error }: { error: unknown }): boolean => {
  if (!(error instanceof AxiosError) || error.response?.status !== 422) {
    return false;
  }

  return getCommunityImportErrorMessages({ error }).some((message) =>
    message.toLowerCase().includes(COMMUNITY_IMPORT_ALREADY_IN_PROGRESS_MESSAGE)
  );
};

export const isCommunityImportNotFoundError = ({ error }: { error: unknown }): boolean =>
  error instanceof AxiosError && error.response?.status === 404;
